export default {
  "nav.home": "Inicio",
  "nav.categories": "Categorías",
  "nav.guides": "Guías",
  "nav.faq": "FAQ",
  "nav.shopGuide": "Guía de compra",

  "hero.badge": "Centro de recursos de USFans Spreadsheet",
  "hero.title": "USFans Spreadsheet: encuentra productos, vendedores y recursos más rápido",
  "hero.subtitle": "Explora los recursos de USFans Spreadsheet, guías de vendedores, investigación de productos, QC, costes de envío, información de almacén, reseñas, cupones y guías de seguridad, todo en un solo lugar.",
  "hero.ctaPrimary": "Explorar USFans Spreadsheet",
  "hero.ctaSecondary": "Ver guías de USFans",
  "hero.note": "Explora las categorías de abajo y salta directo a la tienda principal.",

  "cat.title": "Explora las categorías de productos",
  "cat.subtitle": "Elige una categoría para abrirla en el sitio web principal. Usa el desplegable o pulsa un botón de abajo.",
  "cat.dropdownLabel": "Elige una categoría",
  "cat.dropdownPlaceholder": "Selecciona una categoría…",
  "cat.open": "Abrir en el sitio principal",

  "cat.shoes": "Zapatillas",
  "cat.hoodies": "Sudaderas/Jerséis",
  "cat.tshirts": "Camisetas",
  "cat.jackets": "Chaquetas",
  "cat.pants": "Pantalones/Shorts",
  "cat.headwear": "Gorras",
  "cat.sets": "Conjuntos",
  "cat.underwear": "Ropa interior",
  "cat.jersey": "Camisetas deportivas",
  "cat.accessories": "Accesorios",
  "cat.bags": "Bolsos",
  "cat.belts": "Cinturones",
  "cat.perfumes": "Perfumes",
  "cat.other": "Otras cosas",

  "about.title": "¿Qué es USFans Spreadsheet?",
  "about.p1": "USFans Spreadsheet es un catálogo organizado que agrupa zapatillas, sudaderas, camisetas, camisetas deportivas, accesorios y más en una única lista fácil de recorrer. En lugar de buscar en toda la tienda, puedes saltar directo a la sección que quieras.",
  "about.p2": "Está pensado para ahorrar tiempo: compara productos lado a lado, consulta notas de vendedores y entiende el envío antes de comprar. Piénsalo como un atajo de investigación que te lleva a los productos correctos del sitio web principal.",

  "features.title": "Recursos populares de USFans",
  "features.subtitle": "Guías que te ayudan a comprar mejor y de forma segura.",
  "features.review.title": "Reseña de USFans",
  "features.review.desc": "Qué dicen los compradores sobre productos, vendedores y la experiencia general.",
  "features.shipping.title": "Coste de envío",
  "features.shipping.desc": "Entiende las opciones de envío, la información del almacén y los plazos de entrega.",
  "features.coupon.title": "Cupones y descuentos",
  "features.coupon.desc": "Consejos para encontrar ahorros, cupones y códigos de descuento.",
  "features.safety.title": "Seguridad y legitimidad",
  "features.safety.desc": "¿Es legítimo USFans? Consejos prácticos de seguridad y verificación.",

  "guides.title": "Últimas guías",
  "guides.subtitle": "Artículos originales y en profundidad sobre USFans Spreadsheet.",
  "guides.readMore": "Leer artículo",

  "cta.title": "¿Listo para ver el catálogo completo?",
  "cta.subtitle": "Abre la tienda principal de USFans para ver todos los productos, los precios actuales y completar tu pedido.",
  "cta.primary": "USFans Spreadsheet",
  "cta.secondary": "Comprar Ahora",

  "faq.title": "Preguntas frecuentes",
  "faq.q1": "¿Qué es USFans Spreadsheet?",
  "faq.a1": "Es un catálogo de productos organizado que agrupa ropa urbana y productos para fans por categoría, enlazando con la tienda principal para comprar.",
  "faq.q2": "¿Es gratis explorarlo?",
  "faq.a2": "Sí, explorar las categorías es sencillo. Los precios y el pago se gestionan en el sitio web principal.",
  "faq.q3": "¿Cómo compro un artículo?",
  "faq.a3": "Elige una categoría, ábrela en el sitio web principal y completa allí tu pedido.",
  "faq.q4": "¿Es legítimo USFans?",
  "faq.a4": "Verifica siempre la tienda oficial, los métodos de pago y las políticas antes de comprar, y evita sitios que imitan al original.",

  "footer.tagline": "Un recurso informativo independiente sobre USFans Spreadsheet.",
  "footer.explore": "Explorar",
  "footer.resources": "Recursos",
  "footer.mainSite": "Sitio web principal",
  "footer.disclaimer": "Este sitio web es un recurso informativo independiente. La información puede cambiar con el tiempo. Verifica siempre la información importante antes de comprar, pagar o compartir datos personales.",
  "footer.rights": "Todos los derechos reservados.",
};